var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "kirmizi-santral-cdr" } },
    [
      _c("div", { staticClass: "page-header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c(
              "a-button",
              {
                attrs: { loading: _vm.loading, icon: "reload" },
                on: { click: _vm.refreshData },
              },
              [_vm._v(" Yenile ")]
            ),
            _vm._v(" "),
            _c(
              "a-button",
              {
                attrs: {
                  type: "primary",
                  loading: _vm.loading,
                  icon: "download",
                },
                on: { click: _vm.exportCDR },
              },
              [_vm._v("\n                Dışa Aktar\n            ")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "toolbar" }, [
        _c(
          "div",
          { staticClass: "toolbar-filter" },
          [
            _c("a-input-search", {
              staticClass: "search-input",
              staticStyle: { width: "300px" },
              attrs: {
                placeholder:
                  "CDR ID, Numara, Kaynak Adı veya Unique ID ile ara...",
                loading: _vm.loading,
              },
              on: { search: _vm.onSearch },
              model: {
                value: _vm.searchText,
                callback: function ($$v) {
                  _vm.searchText = $$v
                },
                expression: "searchText",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "date-filter-inline" },
              [
                _c("span", { staticClass: "date-label" }, [
                  _vm._v("Tarih Aralığı:"),
                ]),
                _vm._v(" "),
                _c("a-range-picker", {
                  staticStyle: { width: "250px" },
                  attrs: {
                    format: "DD.MM.YYYY",
                    placeholder: ["Başlangıç", "Bitiş"],
                  },
                  on: { change: _vm.onDateRangeChange },
                  model: {
                    value: _vm.dateRange,
                    callback: function ($$v) {
                      _vm.dateRange = $$v
                    },
                    expression: "dateRange",
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "date-required" }, [_vm._v("*")]),
              ],
              1
            ),
            _vm._v(" "),
            _c("CommonFilterTool", {
              attrs: {
                "keep-state-on-query-params": false,
                "filter-meta": _vm.filterMetas,
                "label-formatter": _vm.filterLabelFormatter,
                "show-clear-all": _vm.breakdownFilter.length > 0,
              },
              on: {
                addFilter: _vm.addFilter,
                removeFilter: _vm.removeFilter,
                clearAll: _vm.clearFilters,
              },
              model: {
                value: _vm.breakdownFilter,
                callback: function ($$v) {
                  _vm.breakdownFilter = $$v
                },
                expression: "breakdownFilter",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "toolbar-actions" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "statistics" }, [
        _c("div", { staticClass: "stats-grid" }, [
          _c("div", { staticClass: "stat-card total-calls" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "stat-content" }, [
              _c("div", { staticClass: "stat-value" }, [
                _vm._v(_vm._s(_vm.statistics.totalCalls)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-label" }, [
                _vm._v("Toplam Arama"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stat-card answered-calls" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "stat-content" }, [
              _c("div", { staticClass: "stat-value" }, [
                _vm._v(_vm._s(_vm.statistics.answeredCalls)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-label" }, [_vm._v("Cevaplanmış")]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-percentage" }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(
                      _vm.statistics.totalCalls > 0
                        ? Math.round(
                            (_vm.statistics.answeredCalls /
                              _vm.statistics.totalCalls) *
                              100
                          )
                        : 0
                    ) +
                    "%\n                    "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stat-card total-duration" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "stat-content" }, [
              _c("div", { staticClass: "stat-value" }, [
                _vm._v(_vm._s(_vm.statistics.totalDuration)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-label" }, [_vm._v("Toplam Süre")]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-unit" }, [_vm._v("dakika")]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stat-card average-duration" }, [
            _vm._m(4),
            _vm._v(" "),
            _c("div", { staticClass: "stat-content" }, [
              _c("div", { staticClass: "stat-value" }, [
                _vm._v(_vm._s(_vm.statistics.averageDuration)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-label" }, [
                _vm._v("Ortalama Süre"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-unit" }, [_vm._v("dakika")]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("SupsisTable", {
            attrs: {
              columns: _vm.getCols(),
              rows: _vm.cdrRecords,
              loading: _vm.loading,
              "top-pagination": "",
              "bottom-pagination": "",
              "pagination-cursor": _vm.pagination,
              options: {
                fixedHeader: true,
                borderX: true,
                borderY: true,
              },
              "pagination-options": [
                10, 20, 30, 40, 50, 100, 200, 300, 400, 500, 1000,
              ],
            },
            on: { "cursor-changed": _vm.onPaginationChange },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: "Arama Detayları", footer: null, width: "700px" },
          model: {
            value: _vm.showDetailModal,
            callback: function ($$v) {
              _vm.showDetailModal = $$v
            },
            expression: "showDetailModal",
          },
        },
        [
          _vm.selectedCall
            ? _c(
                "div",
                [
                  _c(
                    "a-descriptions",
                    { attrs: { column: 2, bordered: "", size: "small" } },
                    [
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "CDR ID" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.selectedCall.cdrid) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("a-descriptions-item", { attrs: { label: "Tarih" } }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm
                                .$moment(_vm.selectedCall.calldate)
                                .format("DD.MM.YYYY HH:mm:ss")
                            ) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "Arayan (CLI)" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.selectedCall.cli) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "Aranan (CLD)" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.selectedCall.cld) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "Yön" } },
                        [
                          _c(
                            "a-tag",
                            {
                              attrs: {
                                color: _vm.getDirectionColor(
                                  _vm.selectedCall.direction
                                ),
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.getDirectionText(
                                      _vm.selectedCall.direction
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "Durum" } },
                        [
                          _c(
                            "a-tag",
                            {
                              attrs: {
                                color: _vm.getStatusColor(
                                  _vm.selectedCall.status
                                ),
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.selectedCall.status) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "Toplam Süre" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.formatDuration(_vm.selectedCall.duration)
                              ) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "Konuşma Süresi" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.formatDuration(_vm.selectedCall.billsec)
                              ) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "Çalma Süresi" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.formatDuration(_vm.selectedCall.ringtime)
                              ) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "SIP Kodu" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.selectedCall.sipcode) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "Uygulama" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.selectedCall.application || "-") +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("a-descriptions-item", { attrs: { label: "DID" } }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.selectedCall.did || "-") +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "Unique ID", span: "2" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.selectedCall.uniqueid) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.selectedCall.recordingfile
                        ? _c(
                            "a-descriptions-item",
                            { attrs: { label: "Kayıt Dosyası", span: "2" } },
                            [
                              _c(
                                "a-button",
                                {
                                  attrs: { size: "small", icon: "play-circle" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.playRecording(_vm.selectedCall)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        Kayıt Dinle\n                    "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.showAudioPlayer
        ? _c("div", { staticClass: "audio-player-dock" }, [
            _c("div", { staticClass: "audio-player-container" }, [
              _c("div", { staticClass: "audio-player-info" }, [
                _c("i", { staticClass: "material-icons audio-icon pulse" }, [
                  _vm._v("music_note"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "audio-title-container" }, [
                  _c("div", { staticClass: "now-playing" }, [
                    _vm._v("Şimdi Çalıyor"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "audio-title" }, [
                    _vm._v(_vm._s(_vm.currentPlayingRecordName)),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "audio-player-wrapper" }, [
                _c("audio", {
                  ref: "audioPlayer",
                  attrs: {
                    controls: "",
                    src: _vm.currentPlayingRecordURL,
                    autoplay: "",
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "audio-player-controls" },
                [
                  _c("a-button", {
                    attrs: {
                      type: "danger",
                      shape: "circle",
                      icon: "close",
                      size: "large",
                    },
                    on: { click: _vm.closeAudioPlayer },
                  }),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("h3", [_vm._v("Arama Kayıtları (CDR)")]),
      _vm._v(" "),
      _c("p", [_vm._v("Kırmızı Santral arama detay kayıtlarını görüntüleyin")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("call")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("call_received")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("schedule")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("timer")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }